import { axios } from '@/services/axios';

const requestNumberPort = async ({
    currentCompany,
    currentScope,
    formData,
}) => {
    const res = await axios.post(
        `/numberblock/requestport/${currentCompany}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-RequestScope': currentScope,
            },
        },
    );
    return res;
};

export default requestNumberPort;
